import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';

export default {
    changePassword: (passwords) => {
        return http.post(API_PATHS.changePassword, passwords);
    }
};
